
export function resultsAreValid(results)
{
    if (results === null | results === undefined) { return false }

    return results.status !== 500
}

export function dropdownsAreValid() { return dropdownsWithDefaultValue().length === 0 }

export function dropdownsWithDefaultValue()
{
    let dropdownsWithDefaultValue = []
    const dropdownElements = document.getElementsByTagName("select")
    for (let i = 0 ; i <= dropdownElements.length - 1 ; i += 1)
    {
        if (dropdownElements[i].value === dropdownElements[i].options[0].value) { dropdownsWithDefaultValue.push(dropdownElements[i]) }
    }

    return dropdownsWithDefaultValue
}

export function getFormData(form)
{
    const data = new FormData(form) // pega todos os inputs com propriedade "name" única dentro de <Form>
    return Object.fromEntries(data.entries())
}
